module.exports = __webpack_public_path__ + "valhala_fenyx_rysing_background_desktop.jpg";